import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import { COUNTRIES } from "../../../../data/constants";
import Modal from "../../shared/components/Modal";
import SelectWrapper from "../../shared/components/SelectWrapper";

/**
 * EditOrderModal
 *
 * Props:
 *   order     object  — the order being edited (used for modal title)
 *   form      { orderId, supplier, country, city }
 *   setForm   (updater) => void
 *   saving    bool
 *   onSave    () => void
 *   onClose   () => void
 */
const EditOrderModal = React.memo(function EditOrderModal({
  order,
  form,
  setForm,
  saving,
  onSave,
  onClose,
}) {
  return (
    <Modal
      title={`Edit Order — ${order.orderId || order.id}`}
      onClose={onClose}
      maxWidth={440}
    >
      <div className={styles.formInner}>
        <input
          className={styles.input}
          placeholder="Supplier *"
          value={form.supplier}
          onChange={(e) => setForm((f) => ({ ...f, supplier: e.target.value }))}
        />

        <div style={{ display: "flex", gap: 10 }}>
          <SelectWrapper
            value={form.country}
            wrapperClassName={styles.flex1}
            onChange={(e) =>
              setForm((f) => ({ ...f, country: e.target.value }))
            }
          >
            <option value="">— Country * —</option>
            {COUNTRIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </SelectWrapper>
          <input
            className={styles.input}
            style={{ flex: 1 }}
            placeholder="City"
            value={form.city}
            onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
          />
        </div>

        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </Modal>
  );
});

export default EditOrderModal;
